define('plugin/client-field/view/BuiltIn/ClientFieldBuiltInAddressView',['require','plugin/additional-fields/view/AdditionalFieldItemView','plugin/client-login/view/ClientProfileFormBehavior'],function (require) {

    var Parent = require('plugin/additional-fields/view/AdditionalFieldItemView');
    
    var ClientProfileFormBehavior = require('plugin/client-login/view/ClientProfileFormBehavior');

    /**
     * Client field item view
     *
     * @class ClientFieldItemView
     */
    return Parent.extend({
        
        behaviors: function () {
            return {
                ClientProfileFormBehavior: {
                    behaviorClass: ClientProfileFormBehavior,
                    model: this.getOption('clientModel')
                }
            };
        },

        getTemplate: function () {
            return '#client_field_built_in_address';
        },
        
        setValue: function (event) {
            var $target = $(event.target);
            var name = $target.attr('name');
            var val = name == 'with_address' ? $target.is(':checked') : $target.val();
            
            this.getOption('clientModel').set(name, val, {silent: true});
        },
        
        serializeData: function () {
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                data: this.getOption('clientModel').toJSON(),
                errors: this.getOption('clientModel').validationError
            }, this.getOption('externalData'));
        }
        
    });

});
